// extracted by mini-css-extract-plugin
export default {"main-wrapper":"CancelUpdatePlan_main-wrapper__IcuZg","cancel-buttons":"CancelUpdatePlan_cancel-buttons__Y-cvg"};